import classNames from 'clsx';
import React from 'react';

import Cross from '../../assets/icons/cross.svg';
import Tick from '../../assets/icons/tick.svg';
import type { LabelProp } from '../hooks/useDisplayLabel/useDisplayLabel';
import { useDisplayLabel } from '../hooks/useDisplayLabel/useDisplayLabel';
import type { Error } from '../validators/validators';

import styles from './ValidationTip.module.scss';

export interface ValidationTipProps {
  element?: string;
  message: Error['message'] | React.ReactNode;
  valid?: boolean | RegExp;
  dirty?: boolean;
}

const ValidationTip: React.FC<ValidationTipProps> = (props) => {
  const { element, message, valid, dirty } = props;
  const Icon = props.valid ? Tick : Cross;
  const tagName = element ? element : 'span';
  const children = useDisplayLabel(message as LabelProp);

  const className = classNames(
    styles.validationTip,
    dirty && valid && styles.valid,
    dirty && !valid && styles.error
  );

  return React.createElement(tagName, { className }, children, dirty && <Icon />);
};

export default ValidationTip;
